import { render, staticRenderFns } from "./feeds.vue?vue&type=template&id=1f8a7611&"
import script from "./feeds.vue?vue&type=script&lang=js&"
export * from "./feeds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports